import { ButtonBase, ButtonBaseProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaCloseIcon } from '../../icons';

const useStyles = makeStyles({ name: 'CloseButton' })((theme) => ({
	root: {
		background: theme.palette.closeButton.background,
		color: theme.palette.closeButton.color,
		stroke: theme.palette.closeButton.color,
		width: 60,
		height: 60,
		[theme.breakpoints.up('md')]: {
			width: 70,
			height: 70
		}
	},
	icon: {
		width: 26,
		height: 26
	}
}));

export const CloseButton: React.FC<ButtonBaseProps> = (props) => {
	const { className, ...other } = props;
	const { classes, cx } = useStyles();

	return (
		<ButtonBase data-test='button-close' {...other} className={cx(classes.root, className)}>
			<SkodaCloseIcon color='inherit' className={classes.icon} />
		</ButtonBase>
	);
};
